import { BoxProps } from '@jfs/ui-new'

export const styles = {
  timerBox: {
    flexDirection: 'row',
    ph: 16,
    ml: 30,
    pv: 5,
    borderWidth: 1,
    alignSelf: 'flex-start',
    borderColor: 'GREY_MATTE',
    borderRadius: 6,
  } as BoxProps,
  timerComp: {
    flexDirection: 'row',
    backgroundColor: 'WHITE',
    borderWidth: 1,
    alignSelf: 'flex-start',
    ph: 10,
    borderRadius: 8,
    borderColor: 'SEPERATOR',
    shadowOffset: { width: -2, height: 3 },
    shadowRadius: 6,
    shadowColor: 'GREY_MATTE',
    position: 'absolute',
    pv: 3,
  } as BoxProps,
  modal: {
    position: 'absolute',
    elevation: 2,
    shadowOpacity: 1,
    opacity: 1,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    borderWidth: 1,
  } as BoxProps,
}
